<template>
  <div>
    <el-container class="layout-container">
      <sidebar />
      <el-main>
        <router-view :key="$route.fullPath" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'LayoutWithMenu',
  components: { Sidebar },
}
</script>

<style lang="scss" scoped>
.layout-container {
  background-color: transparent;
  padding: 10px 0 0 0;
  width: 70%;
  height: 100%;
  margin: auto;
  .el-main {
    padding: 8px 16px 16px 16px;
  }
}
</style>
